import { observer } from 'mobx-react-lite'
import { Label } from 'shared/ui'
import { MessageField } from 'widgets/MessageField'
import { type AgentSMSMessageStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentSMSMessage/store/AgentSMSMessageStore.tsx'

export const AgentSMSMessage = observer(
  ({ store, label }: { store: AgentSMSMessageStore; label?: string }) => {
    const { messageFieldStore, error } = store
    return (
      <div>
        {label && (
          <Label
            label={{
              text: label,
            }}
            marginBottom={4}
          />
        )}
        <MessageField messageFieldStore={messageFieldStore} error={error} />
      </div>
    )
  }
)
